import React from 'react';
import type { MessageDescriptor } from 'react-intl-next';
import { FormattedMessage } from 'react-intl-next';

import { Attribution, TransparentErrorBoundary } from '@confluence/error-boundary';

import { ConfluenceEdition } from '../Upgrade/__types__/waitForEditionChangeQuery';
import type { ChangeEditionSectionMessageProps } from '../SectionMessage/ChangeEditionSectionMessage';
import { SectionMessage } from '../UpsellLooknFeel/SectionMessage';

export type CopySpacePermissionsUpsellProps = Pick<
	ChangeEditionSectionMessageProps,
	'appearanceType' | 'source'
> & {
	messages: Record<'body' | 'title', MessageDescriptor>;
};

export const CopySpacePermissionsUpsell = ({
	messages,
	...props
}: CopySpacePermissionsUpsellProps) => (
	<TransparentErrorBoundary attribution={Attribution.PERMISSIONS_EXPERIENCE}>
		<SectionMessage
			{...props}
			title={<FormattedMessage {...messages.title} />}
			body={<FormattedMessage {...messages.body} tagName="p" />}
			targetEdition={ConfluenceEdition.PREMIUM}
			learnMoreLink={{
				actionSubjectId: 'copySpacePermissionsUpsellLearnMore',
				href: 'https://support.atlassian.com/confluence-cloud/docs/copy-space-permissions/',
			}}
			upgradeEditionActionSubjectId="copySpacePermissionsUpsellTryNow"
			withGradient={false}
		/>
	</TransparentErrorBoundary>
);
